/* eslint-disable import/no-relative-packages */
import {
  getSharedDependencies,
  SharedDependencyId,
  SharedDependencyVersion,
} from '../../../config';

import deprecatedSharedDependencyJson from '../generated/microfrontend-deprecated-shared-dependency-map.json';
import { MicroFrontendDeprecatedSharedDependencyMap } from '../types/shared-dependencies';
import { getEnvironment } from './environment';

/**
 * Get deprecated shared dependency configuration.
 */
export const getDeprecatedSharedDependencyConfig =
  (): MicroFrontendDeprecatedSharedDependencyMap =>
    deprecatedSharedDependencyJson as MicroFrontendDeprecatedSharedDependencyMap;

/**
 * Get the local entrypoint for the given shared dependency.
 * @param sharedDependencyName
 * @param sharedDependencyVersion
 */
export const getEntrypoint = (
  sharedDependencyName: SharedDependencyId,
  sharedDependencyVersion: SharedDependencyVersion
): string => {
  const sharedDependency = getSharedDependencies()[sharedDependencyName];

  const entrypoint = ['dev', 'local'].includes(getEnvironment())
    ? sharedDependency.entrypointDev ?? sharedDependency.entrypoint
    : sharedDependency.entrypoint;

  return `/static/shared-dependencies/${sharedDependencyName}@${sharedDependencyVersion}/${sharedDependency.distFolder}/${entrypoint}`;
};
